var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"tooltip",staticClass:"bg-dark text-white tool-tip",style:(_vm.style)},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }